export const PRICE_CHANNELS_MAP = {
  PBM_PROGRAM: { name: 'Programa PBM', id: 15 },
};
